import basePreview from 'components/shared/images/authbg.jpg';
import { PageVirtualized } from 'components/shared/LandingPage/Virtualizer';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';
import { getAssetSrc } from 'utils/asset';
import { IPage } from 'utils/itineraryDetails/types';

import { usePageContext } from '../context';
import { EPageLayout, IPageConfig } from '../types';

export const useLeftSide = () => {
  const { data, config, virtualized } = usePageContext();
  const {
    primaryImageVersion400,
    primaryImageVersion800,
    primaryImageVersion1200,
    primaryImageVersion1600,
    primaryImageVersion2400,
    primaryImageId,
  } = data;

  const leftSideProps = useLeftSideProps({ page: data, config, virtualized });
  const previewImage = basePreview;
  const pictureSources = [
    {
      media: '(max-width: 768px)',
      srcSet: getAssetSrc(primaryImageVersion400, primaryImageVersion800, primaryImageId),
    },
    {
      media: '(max-width: 1500px)',
      srcSet: getAssetSrc(primaryImageVersion800, primaryImageVersion1600, primaryImageId),
    },
    {
      media: '(min-width: 1501px)',
      srcSet: getAssetSrc(primaryImageVersion1200, primaryImageVersion2400, primaryImageId),
    },
  ];

  return { leftSideProps, previewImage, pictureSources, primaryImageId };
};

export function useLeftSideProps({
  page,
  config,
  virtualized,
}: {
  page: IPage;
  config: IPageConfig;
  virtualized?: Partial<Pick<PageVirtualized, 'rendered'>>;
}) {
  const { isTabletOrMobile } = useMediaBreakpoints();

  return {
    id: isTabletOrMobile || config.layout === EPageLayout.FullWidth ? String(page.id) : undefined,
    ...(virtualized && !virtualized.rendered && { style: { position: 'relative' as const } }),
  };
}
